import React from 'react'
import TableChartIcon from '@mui/icons-material/TableChart';
import TableViewIcon from '@mui/icons-material/TableView';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SnowshoeingIcon from '@mui/icons-material/Snowshoeing';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import SchoolIcon from '@mui/icons-material/School';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import WorkIcon from '@mui/icons-material/Work';
import CastForEducationIcon from '@mui/icons-material/CastForEducation';
import SecurityIcon from '@mui/icons-material/Security';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

export const menu = [
    {
        text: 'Dashboard',
        icon: <DashboardIcon />,
        path: '/admin/DashBoardUpdates',
    },
    {
        text: 'Admission',
        icon: <TableViewIcon />,
        path: '',

        submenu: [
            {
                text: 'View Form',
                icon: <SubdirectoryArrowRightIcon />,
                path: '/admin/AdmissionData',
            },
            {
                text: 'Brochure Leads',
                icon: <SubdirectoryArrowRightIcon />,
                path: '/admin/BrochureData',
            },
        ]
    },
    {
        text: 'Students',
        icon: <SnowshoeingIcon />,
        path: '',

        submenu: [
            {
                text: 'Student',
                icon: <SubdirectoryArrowRightIcon />,
                path: '/admin/addStudent',
            },
            // {
            //     text: 'Course',
            //     icon: <AutoStoriesIcon />,
            //     path: '/admin/addCourse',
            // },
        ]
    },
    {
        text: 'School',
        icon: <HomeWorkIcon />,
        path: '',

        submenu: [
            {
                text: 'Add School',
                icon: <SubdirectoryArrowRightIcon />,
                path: '/admin/addSchool',
            },
            // {
            //     text: 'Course',
            //     icon: <AutoStoriesIcon />,
            //     path: '/admin/addCourse',
            // },
        ]
    },
    {
        text: 'Alumni',
        icon: <SchoolIcon />,
        path: '',

        submenu: [
            {
                text: 'Add Alumni',
                icon: <SubdirectoryArrowRightIcon />,
                path: '/admin/addAlumni',
            },
            {
                text: 'Alumni Request',
                icon: <SubdirectoryArrowRightIcon />,
                path: '/admin/AlumniRequest',
            },
        ]
    },
    {
        text: 'Achievement',
        icon: <EmojiEventsIcon />,
        path: '',

        submenu: [
            {
                text: 'Achievements',
                icon: <SubdirectoryArrowRightIcon />,
                path: '/admin/Achievement',
            },
        ]
    },
    {
        text: 'Event & Notice',
        icon: <LocalActivityIcon />,
        path: '',

        submenu: [
            {
                text: 'Events',
                icon: <SubdirectoryArrowRightIcon />,
                path: '/admin/addEvent',
            },
            {
                text: 'Notice',
                icon: <SubdirectoryArrowRightIcon />,
                path: '/admin/addNotice',
            },
        ]
    },
    {
        text: 'Placement',
        icon: <CastForEducationIcon />,
        path: '',

        submenu: [
            {
                text: 'Recruiters',
                icon: <SubdirectoryArrowRightIcon />,
                path: '/admin/recruiter',
            },
            {
                text: 'Placement Highlights',
                icon: <SubdirectoryArrowRightIcon />,
                path: '/admin/addAlumni',
            },
        ]
    },
    {
        text: 'Career',
        icon: <WorkIcon />,
        path: '',

        submenu: [
            {
                text: 'Career',
                icon: <SubdirectoryArrowRightIcon />,
                path: '/admin/career',
            },
            {
                text: "Hiring Cv's ",
                icon: <SubdirectoryArrowRightIcon />,
                path: '/admin/HiringCv',
            },
           
        ]
    },
    {
        text: 'Blogs',
        icon: <WysiwygIcon />,
        path: '',

        submenu: [
            {
                text: 'Manage Blogs',
                icon: <SubdirectoryArrowRightIcon />,
                path: '/admin/addBlogs',
            },
            {
                text: 'Public Blogs',
                icon: <SubdirectoryArrowRightIcon />,
                path: '/admin/PublicBlogs',
            },
            
        ]
    },
    {
        text: 'Anti Ragging',
        icon: <SecurityIcon />,
        path: '',
        submenu: [
            {
                text: 'View Table',
                icon: <SubdirectoryArrowRightIcon />,
                path: '/admin/RaggingPage',
            },
            
        ]
    },
    {
        text: 'Gallery Image',
        icon: <SecurityIcon />,
        path: '/admin/gallery',
    },
    // {
    //     text: 'Users List',
    //     icon: <DashboardIcon />,
    //     path: '/admin/UsersList',
    // },
    // {
    //     text: 'Feedbacks',
    //     icon: <TableChartIcon />,
    //     path: '',
    // },

]
